/* eslint-disable no-shadow */

import actions from './actions';
import mutations from './mutations';

const state = {
  appId: null,
  id: null,
  name: '',
  subdomain: '',
  displayName: '',
  logoUri: '',
  parentId: null,
  parent: null,
  children: null,
  accessDetails: {},
  assuranceApiKey: null,
  assuranceTenant: null
};

const getters = {
  isSingleSite: (state) =>
    state.parentId === null && ((state.children && state.children.length === 0) || !state.children),

  hasCompliLearnSites: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'hasCompliLearnSites') &&
    state.accessDetails.hasCompliLearnSites,

  isUgcEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isUgcEnabled') &&
    state.accessDetails.isUgcEnabled,

  isAssuranceIntegrationEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isAssuranceIntegrationEnabled') &&
    state.accessDetails.isAssuranceIntegrationEnabled,

  isSecureUgcModulesEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isSecureUgcModulesEnabled') &&
    state.accessDetails.isSecureUgcModulesEnabled,

  isContextKeyPreferencesEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isContextKeyPreferencesEnabled') &&
    state.accessDetails.isContextKeyPreferencesEnabled,

  isLoginBannerEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isLoginBannerEnabled') &&
    state.accessDetails.isLoginBannerEnabled
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
